import React from 'react';
import SkeletonLoader from './SkeletonLoader';

export default function TreeDetailsLoading() {
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      <div className="container mx-auto px-4 py-8">
        {/* Back Button Skeleton */}
        <div className="mb-6">
          <SkeletonLoader variant="text" className="w-32 h-6" />
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="md:flex">
            {/* Image Skeleton */}
            <div className="md:flex-1">
              <SkeletonLoader className="w-full h-[400px] md:h-[600px]" />
            </div>

            {/* Content Skeleton */}
            <div className="md:w-96 p-6 md:p-8">
              {/* Title */}
              <SkeletonLoader variant="text" className="w-3/4 h-8 mb-6" />

              {/* Info Items */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <SkeletonLoader variant="circular" width={20} height={20} />
                  <SkeletonLoader variant="text" className="w-1/2 ml-2" />
                </div>
                <div className="flex items-center">
                  <SkeletonLoader variant="circular" width={20} height={20} />
                  <SkeletonLoader variant="text" className="w-2/3 ml-2" />
                </div>
                <div className="flex items-center">
                  <SkeletonLoader variant="circular" width={20} height={20} />
                  <SkeletonLoader variant="text" className="w-1/3 ml-2" />
                </div>
              </div>

              {/* Description Skeleton */}
              <div className="bg-gray-50 rounded-lg p-4 mb-8">
                <SkeletonLoader variant="text" className="w-full" repeat={3} />
              </div>

              {/* Buttons Skeleton */}
              <div className="space-y-4">
                <SkeletonLoader className="w-full h-12 rounded-lg" />
                <SkeletonLoader className="w-full h-12 rounded-lg" />
              </div>

              {/* Social Share Skeleton */}
              <div className="mt-6 pt-4 border-t">
                <div className="flex justify-between">
                  <div className="flex space-x-2">
                    {[1, 2, 3, 4].map((i) => (
                      <SkeletonLoader key={i} variant="circular" width={32} height={32} />
                    ))}
                  </div>
                  <SkeletonLoader variant="text" className="w-20" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}